import * as React from 'react';
import Loading from './Loading';
import Failure from './Failure';
import Cost from '../logic/domain/cost/Cost';

interface Props {
  isLoading: boolean;
  cost: Cost;
}

const costView = (props: Props) => {
  if (props.isLoading) {
    return <Loading />;
  }
  if (props.cost) {
    return <span>{props.cost.cost} 円</span>;
  }
  return <Failure errorMessage="Failure" />;
};

export default costView;



// WEBPACK FOOTER //
// ./src/components/CostView.tsx